import Yup from "../validationsLib";

/**
 * Validations rules for the setting page
 */

export default Yup.object().shape({
    role_name: Yup.string()
        .required("Role name cannot be blank!"),
});